import React, { useState, useEffect, useMemo } from 'react';
import { get } from '../services/api';
import PowerfulTable from './PowerfulTable/PowerfulTable';
import Loading from './Loading/Loading';

export default function OrdersList(props) {
  const [orders, setOrders] = useState(null);
  const [filter, setFilter] = useState('');
  const [showCancelled, setShowCancelled] = useState(false);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const fetchOrders = async () => {
      const initialOrders = await get(`/admin/orders?limit=50`);
      if (isMounted) {
        setOrders(initialOrders || []);
      }

      get(`/admin/orders?limit=10000&skip=50`).then(rest => {
        if (isMounted && rest && rest.length > 0) {
          setOrders(prev => {
            const existingIds = new Set((prev || []).map(o => o.courseId));
            const newUniqueOrders = rest.filter(o => !existingIds.has(o.courseId));
            return [...(prev || []), ...newUniqueOrders];
          });
        }
      });
    };

    if (!props.orders) {
      fetchOrders();
    } else {
      setOrders(props.orders);
    }

    return () => { isMounted = false; };
  }, [props.orders]);

  const filteredData = useMemo(() => {
    if (!orders) return null;

    const s = filter.toLowerCase();
    const in1Month = new Date();
    in1Month.setMonth(in1Month.getMonth() + 1);

    return orders.filter((o) => {
      const matchesFilter = s === '' || Object.values(o).some(val =>
        String(val).toLowerCase().includes(s)
      );

      const matchesDate = showAll || new Date(o.date) < in1Month;
      const matchesStatus = showCancelled || (o.status !== 'PUPIL_CANCELLED' && o.status !== 'TUTOR_CANCELLED');

      return matchesFilter && matchesDate && matchesStatus;
    });
  }, [orders, filter, showAll, showCancelled]);

  if (!filteredData) return <Loading />;

  return (
    <div>
      <div style={{ marginLeft: 20 }}>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2>Cours ({filteredData.length})</h2>
          <div>
            <label style={{ marginRight: 5 }}>Afficher les cours annulés</label>
            <input type='checkbox' checked={showCancelled} onChange={(e) => setShowCancelled(e.target.checked)} />
          </div>
          <div>
            <label style={{ marginRight: 5 }}>Afficher tous les cours</label>
            <input type='checkbox' checked={showAll} onChange={(e) => setShowAll(e.target.checked)} />
          </div>
          <div style={{ marginRight: 50 }}>
            <input
              placeholder='Rechercher'
              type='text'
              onChange={(e) => setFilter(e.target.value)}
              value={filter}
              style={{ paddingLeft: 10, width: 180, height: 30, borderRadius: 30, boxShadow: 'none', borderStyle: 'hidden', backgroundColor: '#eee', outline: 'none' }}
            />
          </div>
        </div>

        {filteredData.length > 0 && <PowerfulTable
          data={filteredData}
          types={{
            courseId: { name: 'id' },
            status: { name: 'statut' },
            subject: { name: 'matière' },
            level: { name: 'niveau' },
            date: { name: 'date' },
            duration: { name: 'durée' },
            createdOn: { name: 'commandé le' },
            pupil: { name: 'élève' },
            teacher: { name: 'professeur' },
            newOrder: { name: 'Nouveau' },
          }}
          redirect={'orders'}
          redirectKey={'courseId'}
        />}
        {filteredData.length === 0 && orders && orders.length > 0 && <p style={{ width: '100%', textAlign: 'center' }}>Aucun cours ne correspond à vos filtres.</p>}
        {orders && orders.length === 0 && <p style={{ width: '100%', textAlign: 'center' }}>Aucun cours.</p>}
      </div>
    </div>
  );
}
